<script>
export default {
  components: {},
  props: {
    date: {
      type: String,
      required: false,
      default: null
    },
    image: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: true,
      default: null
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<template>
  <div class="base-card-header" :style="!image ? 'padding: 0;' : ''">
    <img class="icon-base-card-header" :src="image" v-if="image"/>
    <h5 class="base-card-header-title">
      {{ title }}
      <small v-if="date">{{ date }}</small>
    </h5>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-card-header {
  display: flex;
  margin-bottom: 2rem;
  padding: 0 2.5rem;

  .icon-base-card-header {
    height: 3.7rem;
    margin-right: 1.35rem;
    width: 2.8rem;
  }

  .base-card-header-title {
    margin-bottom: 0;

    small {
      color: $color-gray;
      display: block;
      font-weight: 800;
      line-height: 1.3;
    }
  }
}
</style>
